import Phaser from 'phaser';

export class MenuScene extends Phaser.Scene {
    constructor() {
        super({ key: 'MenuScene' });
    }

    preload(): void {
        // Load the example image to use as reference/style guide
        this.load.image('homepageExample', '/art/homepageexample.jpg');
        
        // Load the title video
        this.load.video('sombreroTitle', '/art/SombreroTitle.mp4');
    }

    create(): void {
        // Completely remove the ad banner from the DOM on the menu screen
        const adElement = document.getElementById('ad-bottom');
        if (adElement) {
            adElement.remove();
        }
        
        const gameWidth = 360;
        const centerX = gameWidth / 2;
        
        // Match example style - typically retro arcade uses dark background
        this.cameras.main.setBackgroundColor('#000000');
        
        // Layout with proper spacing - centered and balanced
        // 1. Video on top - natural size, centered
        const videoY = 40;
        const video = this.add.video(centerX, videoY, 'sombreroTitle');
        video.setOrigin(0.5, 0); // Anchor at top center
        video.setDepth(1);
        video.play(true); // Loop the video
        
        // Calculate positions based on video height to prevent overlap
        // Use a reasonable estimate for video height, then adjust when loaded
        const estimatedVideoHeight = 250;
        const spacingAfterVideo = 50; // Space between video and title
        
        // 2. Title of game beneath video - ensure no overlap, centered
        const titleY = videoY + estimatedVideoHeight + spacingAfterVideo;
        const title = this.add.text(
            centerX,
            titleY,
            'SOMBRERO TOSS',
            {
                fontSize: '32px',
                color: '#ffffff',
                fontFamily: 'Courier New, monospace',
                fontStyle: 'bold',
                align: 'center'
            }
        ).setOrigin(0.5, 0.5).setDepth(10);
        
        // 3. High score beneath title - good spacing, centered
        const highScoreY = titleY + 45;
        // Get high score from localStorage or default to 0
        const highScore = parseInt(localStorage.getItem('sombreroTossHighScore') || '0', 10);
        const highScoreText = this.add.text(
            centerX,
            highScoreY,
            `HIGH SCORE: ${highScore.toLocaleString()}`,
            {
                fontSize: '18px',
                color: '#ffffff',
                fontFamily: 'Courier New, monospace',
                fontStyle: 'bold',
                align: 'center'
            }
        ).setOrigin(0.5, 0.5).setDepth(10);
        
        // 4. Play button - centered with good spacing
        const buttonY = highScoreY + 45;
        const buttonBg = this.add.rectangle(
            centerX,
            buttonY,
            200,
            50,
            0x4169E1
        ).setDepth(10).setInteractive({ useHandCursor: true });
        
        const buttonText = this.add.text(
            centerX,
            buttonY,
            'PLAY',
            {
                fontSize: '24px',
                color: '#ffffff',
                fontFamily: 'Courier New, monospace',
                fontStyle: 'bold',
                align: 'center'
            }
        ).setOrigin(0.5, 0.5).setDepth(11);
        
        // Button hover effect
        buttonBg.on('pointerover', () => {
            buttonBg.setFillStyle(0x6b9fff);
        });
        
        buttonBg.on('pointerout', () => {
            buttonBg.setFillStyle(0x4169E1);
        });
        
        // 5. Brief instructions - centered with good spacing, ensure they fit on screen
        const instructionsY = buttonY + 70;
        const instructions = this.add.text(
            centerX,
            instructionsY,
            'Swipe/Click+Drag to toss a sombrero\nToss Sombreros on the DEMs\nbut not the GOP',
            {
                fontSize: '16px',
                color: '#ffffff',
                fontFamily: 'Courier New, monospace',
                fontStyle: 'bold',
                align: 'center',
                lineSpacing: 5
            }
        ).setOrigin(0.5, 0.5).setDepth(10);
        
        // Adjust positions when video loads to ensure no overlap
        video.on('loadeddata', () => {
            const actualVideoHeight = video.height;
            const newTitleY = videoY + actualVideoHeight + spacingAfterVideo;
            
            // Update all positions based on actual video height with tighter spacing
            title.setY(newTitleY);
            highScoreText.setY(newTitleY + 45);
            buttonBg.setY(newTitleY + 45 + 45);
            buttonText.setY(newTitleY + 45 + 45);
            // Ensure instructions fit on screen (640px height, leave room for banner ad)
            const calculatedInstructionsY = newTitleY + 45 + 45 + 70;
            // If instructions would be too low, adjust upward
            if (calculatedInstructionsY > 580) {
                // Adjust all elements up slightly
                const adjustment = calculatedInstructionsY - 580;
                title.setY(newTitleY - adjustment);
                highScoreText.setY(newTitleY + 45 - adjustment);
                buttonBg.setY(newTitleY + 45 + 45 - adjustment);
                buttonText.setY(newTitleY + 45 + 45 - adjustment);
                instructions.setY(580);
            } else {
                instructions.setY(calculatedInstructionsY);
            }
        });
        
        // Start game when button is clicked
        buttonBg.on('pointerdown', () => {
            this.scene.start('GameScene');
        });
    }
}
